import { localizationInfoProviderToken } from "@/tokens";
import { InjectionKey } from "@lib/svelte-typed-context";
import { CartModule } from "@modules/cart/CartModule";
import { CommonModule } from "@modules/common_module/CommonModule";
import { ShopifyDiscountModule } from "@modules/discount/ShopifyDiscountModule";
import { container } from "tsyringe";

import { nudgesContextToken } from "./context_tokens";
import NudgesQuery from "./queries/NudgesQuery";
import NudgesService from "./services/NudgesService";
import NudgesPopUpWidgetVisibilityManager from "./widgets/utils/NudgesPopUpWidgetVisibilityManager";

let context: Map<InjectionKey<string>, typeof nudgesContextToken>;

export const getNudgesContext = () => {
    if (!context) {
        context = new Map([
            [
                nudgesContextToken,
                {
                    //nudges popup launcher
                    NudgesPopUpWidgetVisibilityManager: container.resolve(
                        NudgesPopUpWidgetVisibilityManager
                    ),

                    //nudges
                    nudgesService: container.resolve(NudgesService),
                    nudgesQuery: container.resolve(NudgesQuery),

                    //cartService
                    cartService:
                        container.resolve(CartModule).exports.cartService,
                    cartQuery: container.resolve(CartModule).exports.cartQuery,

                    //shopifyDiscount
                    shopifyDiscountApiService: container.resolve(
                        ShopifyDiscountModule
                    ).exports.shopifyDiscountApiService,
                    shopifyDiscountQuery: container.resolve(
                        ShopifyDiscountModule
                    ).exports.shopifyDiscountQuery,

                    //locationController
                    locationController:
                        container.resolve(CommonModule).exports
                            .locationController,

                    urlsBuilder:
                        container.resolve(CommonModule).exports.urlsBuilder,

                    //localizationInfoProvider
                    localizationInfoProvider: container.resolve(
                        localizationInfoProviderToken
                    ),
                },
            ],
        ]);
    }

    return context;
};
